import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, RequestOptions} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import { materialUI } from "./module/new-pages/materialUI";
// import { NgZorroAntdModule } from 'ng-zorro-antd';

import {BwComponent} from './bw.component';
import {ROOT_ROUTING} from './bw.routing';
import {LoadingComponentComponent} from './components/loading-component/loading-component.component';
import {IndexOperationModule} from './module/index-operation/index-operation.module';
import {AliyunService} from './services/aliyun/aliyun.service';
import {MentalsealAdminService} from './services/entity-base/entity-service/mentalseal-admin.service';
import {MentalsealAppService} from './services/entity-base/entity-service/mentalseal-app.service';
import {HttpInterceptorBackend} from './services/http/connection-backend.service';
import {CustomRequestOptions} from './services/http/custom-request-options.service';
import {HttpInterceptor} from './services/http/http-interceprot.service';
import {ImageCropperService} from './services/image-cropper/image-cropper.service';
import {LoadingService} from './services/loading/loading.service';
import {entityReducer} from './services/reducer/entity-reducer.service';
import {RoutingCenterService} from './services/routing-center/routing-center.service';
import {SweetAlertService} from './services/sweet-alert/sweet-alert.service';
import {UserInfoService} from './services/user-info/user-info.service';
require('assets/js/jquery-3.1.1.min.js');
require('assets/js/bootstrap.min.js');

@NgModule({
  declarations: [
    BwComponent,
    LoadingComponentComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ROOT_ROUTING,
    IndexOperationModule,
    StoreModule.provideStore({ entity: entityReducer }),
    StoreDevtoolsModule.instrumentOnlyWithExtension(),
    // NgZorroAntdModule.forRoot(),
    BrowserAnimationsModule,
    materialUI
  ],
  providers: [
    AliyunService,
    SweetAlertService,
    ImageCropperService,
    RoutingCenterService,
    LoadingService,
    HttpInterceptor,
    HttpInterceptorBackend,
    MentalsealAppService,
    MentalsealAdminService,
    UserInfoService,
    // {provide:Http,useFactory:httpFactory,deps:[HttpInterceptorBackend,RequestOptions]}
    {provide: RequestOptions, useClass: CustomRequestOptions}
  ],
  bootstrap: [BwComponent]
})
export class BwModule {
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/bw.module.ts